import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { District } from '@ascschool/model/category/district.model';
import { Ward } from '@ascschool/model/category/ward.model';
import { Account } from '@ascschool/model/user/account';
import { SystemUser } from '@ascschool/model/user/system-user.model';
import { GroupService } from '@ascschool/services/user/group.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SystemUserService } from '@ascschool/services/user/system-user.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-thong-tin-nguoi-dung',
  templateUrl: './thong-tin-nguoi-dung.component.html',
  styleUrls: ['./thong-tin-nguoi-dung.component.scss']
})
export class ThongTinNguoiDungComponent implements OnInit {
  @Input() value: any;
  currentUser : any;
  isEditMode = false;
  district = new District();
  errorMsg: string;
  isDisabled = false;
  typePic = '';
	getGroupACFn: (value: any) => Observable<any>;
	groupSubscription: any;
  isLoading: boolean;
	account = new Account();
	user = new SystemUser();
	positionsList: any;
  ward = new Ward();
  parent: any;
	userName: number;
  validateForm = this.fb.group({
    id: [null],
    normalizedUserName:[null],
    userName: [null, [Validators.required]],
    fullName: [null, [Validators.required]],
    address: [null],
    email: [null],
    phoneNumber: [null],
    groupId: [null],
    passwordHash: [null],
    confirmPassword: [null],
    isActivity: [null],
    // emailConfirmed: [null],
  });
  groupControl = this.validateForm.controls.groupId;
  constructor(
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private service: SystemUserService,
    private fb: FormBuilder,
    private groupService: GroupService,
    private drawerRef: NzDrawerRef,
  ) {
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    this.getAccountInfo();
		this.loadGroup();
  }
	loadGroup() {
		this.getGroupACFn = (value: any) => this.groupService.getGroupSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
			map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.groupName })) : [{ id: null, text: 'Không có dữ liệu' }])
		);
		if (!this.groupSubscription) this.groupSubscription = this.groupControl.valueChanges.subscribe(() => {
			this.utilsService.bindOrUnBindTheId(this.account, 'groupId', this.groupControl.value);
		});
	}
	changeGroup(control: FormControl) {
		this.groupControl = control;
	}
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.drawerRef.close(true);
  }
  getAccountInfo() {
    const obj = new JwtHelperService().decodeToken(JSON.parse(localStorage.getItem('userSetting')).token);
    if(this.currentUser.accountType === 5 || this.currentUser.accountType === 6)
    {
      this.service.getSystemUsersById(obj.uid).subscribe(resp => {
        let userAvatar = <HTMLImageElement>document.getElementById('userAvatar');
        const positionAC = <HTMLInputElement>document.getElementById('positionAC');
        this.validateForm.setValue(resp);
        this.groupService.getGroupById(resp.groupId).subscribe((res) => {
          this.groupControl.setValue({id: res.id, text: res.groupName});
        });
      });
    }else{
      this.service.GetSelectPagingById(obj.uid).subscribe(resp => {
        let userAvatar = <HTMLImageElement>document.getElementById('userAvatar');
        const positionAC = <HTMLInputElement>document.getElementById('positionAC');
        this.validateForm.setValue(resp);
        this.groupService.getGroupById(resp.groupId).subscribe((res) => {
          this.groupControl.setValue({id: res.id, text: res.groupName});
        });
      });
    }

	}
  uploadFile(event, typePic: string) {
		this.typePic = typePic;
		let fileList: FileList = event.target.files;
		if (fileList.length > 0) {
			const file: File = fileList[0];
			var pattern = /image-*/;
			var reader = new FileReader();
			if (!file.type.match(pattern)) {
				alert('invalid format');
				return;
			}
			reader.readAsDataURL(file);
		}
	}
  UpdateClose(){
    const account = this.validateForm.value;
    const obj = new JwtHelperService().decodeToken(JSON.parse(localStorage.getItem('userSetting')).token);
    this.account.id = obj.uid;
    // const passwordHash = this.utilsService.md5Encode(null);
    this.validateForm.controls['passwordHash'].setValue(null);
    this.validateForm.controls['isActivity'].setValue(1);
    // this.validateForm.controls['emailConfirmed'].setValue(0);
    account.groupId = account.groupId.id;
    // delete account.passwordHash;
    // delete account.confirmPassword;
    this.service.updateInfoUsers(account).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        }else{
          this.notification(res);
        }
      });
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }

}
